<template>
  <div>
    <div class="page flex-col">
    <!-- 头部导航组件 -->
    <HeaderNav />
    
    <div class="group_1 flex-col">
      <!-- 统一的顶部装饰和图片 -->
      <div class="box_1-spacer flex-col"></div>
      <div class="box_2 flex-col"></div>
      <img
        class="image_1"
        referrerpolicy="no-referrer"
        src="/files/images/M1.jpg"
      />
      <div class="box_3 flex-row">
        <img
          class="image_2"
          referrerpolicy="no-referrer"
          src="./assets/img/9e899d7ce675d01c87931ce9c12caf6b.png"
        />
        <div class="block_1 flex-row">
          <div class="block_2 flex-col justify-between">
            <div class="box_5 flex-row">
              <span class="text_2">PARK&nbsp;INTRODUCTION</span>
              <div class="box_6 flex-col"></div>
              <span class="text_3">园区介绍</span>
            </div>
            <img
              class="image_3"
              referrerpolicy="no-referrer"
              src="./assets/img/0723a036582961a6f83f80d36917e199.png"
            />
          </div>
          <div class="box_4 flex-col"></div>
          <div class="text-wrapper_1 flex-col">
            <span class="text_1">园区概况</span>
            <div 
              class="paragraph_1"
              v-html="parkInfo || '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;常山陵园位于石家庄市学府路（原五七路）121号，省军区农场北侧，占地245亩，地势平坦，海拔76.8米。始建于94年底，系河北省民政厅批准兴建并颁发（墓证字第12号）经营许可证的合法经营性公墓，为正定县民政局下属事业单位。<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;陵园首期开发一百二十亩，分四十个区。碑石采用优质天然石材，融南北风格为一体。陵园安葬形式主要以墓穴安葬为主，节地生态安葬为辅。墓碑坐北面南，符合民风，顺乎民意。将故人安葬于此，是您理想的选择。<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;常山陵园南临汉河，北依源泥河，即将新建的万苗森林公园在其附近，风景怡人……'"
            ></div>
          </div>
        </div>
      </div>
      <div class="box_7 flex-row">
        <div class="group_2 flex-col">
        </div>
        <div class="group_4 flex-col">
          <div class="block_3 flex-row justify-between">
            <span class="text_7">园区设施</span>
            <img
              class="image_6"
              referrerpolicy="no-referrer"
              src="./assets/img/009391fde4d831b0e71a048752f490fc.png"
            />
          </div>
          <span class="text_8">PARK&nbsp;FACILITIES</span>
          <div class="boxes-container flex-row" data-v-30c8f708>
            <div class="box_8 flex-col">
              <div class="image-text_1 flex-row justify-between">
                <img
                  class="image_4"
                  referrerpolicy="no-referrer"
                  src="./assets/img/14e4ea954a368a3fde7650480f19739d.png"
                />
                <div class="text-group_1 flex-col justify-between">
                  <span class="text_4">园区环境</span>
                  <span class="text_5">Park&nbsp;Environment</span>
                </div>
              </div>
              <div class="group_3 flex-col"></div>
              <span class="text_6">常山陵园环境优美，绿树成荫，鸟语花香，为逝者提供宁静安详的安息之所。</span>
            </div>
            <div class="box_9 flex-col">
              <div class="image-text_1 flex-row justify-between">
                <img
                  class="image_4"
                  referrerpolicy="no-referrer"
                  src="./assets/img/1c42e9ad86ee7a95a7840121990def1f.png"
                />
                <div class="text-group_1 flex-col justify-between">
                  <span class="text_4">园区规划</span>
                  <span class="text_5">Park&nbsp;Planning</span>
                </div>
              </div>
              <div class="group_3 flex-col"></div>
              <span class="text_6">园区规划科学合理，分为多个功能区，包括传统墓区、生态葬区、纪念区等，满足不同需求。</span>
            </div>
            <div class="box_11 flex-col">
              <div class="image-text_1 flex-row justify-between">
                <img
                  class="image_4"
                  referrerpolicy="no-referrer"
                  src="./assets/img/5287678034ee8f4dc5deac9616188ec0.png"
                />
                <div class="text-group_1 flex-col justify-between">
                  <span class="text_4">交通便利</span>
                  <span class="text_5">Convenient&nbsp;Transportation</span>
                </div>
              </div>
              <div class="group_3 flex-col"></div>
              <span class="text_6">园区交通便利，多条公交线路直达，方便家属前来祭扫和参观。</span>
            </div>
          </div>
        </div>
      </div>
      <div class="box_13 flex-row">
        <span class="text_14">PARK&nbsp;MAP</span>
        <div class="box_14 flex-col"></div>
        <span class="text_15">园区地图</span>
        <div class="box_15 flex-col">
          <img
            v-if="siteConfig && siteConfig.pic1"
            class="park-map"
            :src="getImageUrl(siteConfig.pic1)"
            alt="园区分区图"
            referrerpolicy="no-referrer"
          />
          <img
            v-else
            class="park-map"
            referrerpolicy="no-referrer"
            src="./assets/img/404c4ea575fb071f1e144fedbc62f0a8.png"
          />
        </div>
      </div>
    </div>
    </div>
    <!-- 联系我们部分 - 独立整体 -->
    <ContactUsSection />
  </div>
</template>
<script>
import HeaderNav from '@/components/HeaderNav.vue';
import ContactUsSection from '@/components/ContactUsSection.vue';
import { getSiteConfig } from '@/store/siteConfig';
import { getImageUrl } from '@/config/api';

export default {
  components: {
    HeaderNav,
    ContactUsSection
  },
  data() {
    return {
      constants: {},
      siteConfig: null,
      parkInfo: ''
    };
  },
  created() {
    // 获取网站配置
    this.siteConfig = getSiteConfig();
    // 可以从配置中获取园区介绍信息，或者使用默认内容
    this.parkInfo = this.siteConfig?.company_desc || '';
  },
  methods: {
    getImageUrl(imgPath) {
      return getImageUrl(imgPath);
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
.footer-wrapper {
  position: absolute;
  left: 82px;
  top: 3077px;
}

.park-map {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* 隐藏园区介绍页面的下划线元素，统一使用 HeaderNav 组件的下划线 */
/* 统一的顶部装饰和图片样式 */
.box_1-spacer {
  background-color: rgba(255, 255, 255, 1) !important;
  width: 100% !important;
  max-width: 1920px !important;
  height: auto !important;
  min-height: 100px !important;
  margin: 0 auto !important;
  box-sizing: border-box !important;
}

.box_2 {
  background-color: rgba(0, 149, 151, 1) !important;
  width: 100% !important;
  max-width: 36px !important;
  height: 4px !important;
  margin: 50px auto 0 !important;
  box-sizing: border-box !important;
}

.image_1 {
  width: 100% !important;
  max-width: 1918px !important;
  height: auto !important;
  min-height: 398px !important;
  margin: -53px auto 0 !important;
  object-fit: cover !important;
  display: block !important;
  box-sizing: border-box !important;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .box_1-spacer {
    min-height: 80px !important;
  }

  .box_2 {
    margin: 30px auto 0 !important;
  }

  .image_1 {
    margin: -40px auto 0 !important;
    min-height: 300px !important;
  }

  .page {
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: hidden !important;
  }

  .group_1 {
    width: 100% !important;
    padding: 10px !important;
  }

  .box_3 {
    flex-direction: column !important;
    width: 100% !important;
    margin: 20px 0 !important;
  }

  .block_1 {
    width: 100% !important;
    flex-direction: column !important;
    margin: 10px 0 !important;
  }

  .text-wrapper_1 {
    width: 100% !important;
    padding: 20px !important;
  }

  .text_1 {
    font-size: 20px !important;
  }

  .paragraph_1 {
    font-size: 14px !important;
    line-height: 1.6 !important;
  }

  .box_7 {
    flex-direction: column !important;
    width: 100% !important;
    padding: 20px 10px !important;
  }

  .group_2, .group_4 {
    width: 100% !important;
    margin: 10px 0 !important;
  }

  .box_13 {
    flex-direction: column !important;
    width: 100% !important;
    margin: 20px 0 !important;
    padding: 0 10px !important;
  }

  .box_15 {
    width: 100% !important;
    margin: 10px 0 !important;
  }

  .box_21 {
    flex-direction: column !important;
    width: 100% !important;
    padding: 20px 10px !important;
  }

  .box_22, .box_23 {
    width: 100% !important;
    margin: 10px 0 !important;
  }

  .footer-wrapper {
    position: relative !important;
    width: 100% !important;
    left: 0 !important;
    top: auto !important;
  }
}
</style>

